import { AttributeProps } from 'src/components/conteudoProdutos/types'
import { Variation } from 'src/services/marketplace-api/dtos'
import { ProductDetailsUrlData } from 'src/types/ProductDetailsUrlData'
import { ProductCombinationAttributeSlug } from './enums/product-combination-attribute-slug'
import { ProductCombinationValueSlug } from './enums/product-combination-value-slug'

export const findVariationByColorAndVoltage = (
  variations: Array<Variation>,
  colorSlug = ProductCombinationValueSlug.NoColor.valueOf(),
  voltageSlug = ProductCombinationValueSlug.NoVoltage.valueOf()
) => {
  return variations?.find((item) => {
    const combinationByColor = item?.combinacoes?.find((combination) => {
      return (
        combination?.atributo_slug === ProductCombinationAttributeSlug.Color &&
        combination?.valor_slug === colorSlug
      )
    })
    const combinationByVoltage = item?.combinacoes?.find((combination) => {
      return (
        combination?.atributo_slug ===
          ProductCombinationAttributeSlug.Voltage &&
        combination?.valor_slug === voltageSlug
      )
    })

    return combinationByColor && combinationByVoltage
  })
}

export const voltagesWithoutVoltages = (uniqueVoltages: AttributeProps[]) => {
  return uniqueVoltages.reduce((acc: number, current) => {
    if (current.slug == 'sem-voltagem') {
      acc + 1
    }

    return acc
  }, 0)
}

export const voltagesWithVoltages = (uniqueVoltages: AttributeProps[]) => {
  return uniqueVoltages.reduce((acc: number, current) => {
    if (current.slug !== 'sem-voltagem') {
      acc++
    }
    return acc
  }, 0)
}

export const isUniqueVariation = (
  uniqueColors: AttributeProps[],
  uniqueVoltages: AttributeProps[]
) => {
  return (
    (uniqueColors.length < 1 && voltagesWithoutVoltages(uniqueVoltages) > 1) ||
    uniqueColors.length == 1 ||
    voltagesWithVoltages(uniqueVoltages) == 1
  )
}

export const isCompostVariation = (
  uniqueColors: AttributeProps[],
  uniqueVoltages: AttributeProps[]
) => {
  return (
    voltagesWithVoltages(uniqueVoltages) > 1 ||
    uniqueColors.length > 1 ||
    (voltagesWithVoltages(uniqueVoltages) > 1 && uniqueColors.length > 1)
  )
}

export const isProductDetailsUrlCorrect = (
  current: ProductDetailsUrlData,
  expected: ProductDetailsUrlData
): boolean =>
  expected.description === current.description &&
  expected.id === current.id &&
  expected.colorSlug === current.colorSlug &&
  expected.voltageSlug === current.voltageSlug

export const makeProductUrlFromData = (data: ProductDetailsUrlData): string => {
  const productPath = `${data.description}/${data.id}`
  const variationPath = `${data.colorSlug}/${data.voltageSlug}`
  const queryParams = data.queryParams ? `?${data.queryParams}` : ''

  return `/produto/${productPath}/${variationPath}${queryParams}`
}
